// React
export * from "./context";
export * from "./hooks";
export * from "./components";
export * from "./types";

// Re-export principais para conveniência
export { ACLProvider, useACLContext } from "./context";
export {
  useACL,
  useCan,
  useCanMultiple,
  useCanAny,
  useCanAll,
  usePermissions,
  useEvaluate,
  useRoleHierarchy,
  usePermissionHelpers,
  usePermissionChange,
} from "./hooks";
export {
  Can,
  Cannot,
  IfCan,
  CanAny,
  CanAll,
  withCan,
  PermissionClass,
} from "./components";
